export const documentIds = {
    ALERT_BAR: 'alertBar'
}